export interface DropdownItem {
  id: string | number;
  name: string;
  ParentId?: string | number;
}
export interface DropdownScopeState {
  common: { [key: string]: DropdownItem[] };
  countries: DropdownItem[];
  states: DropdownItem[];
  lgas: DropdownItem[];
}

export interface DropdownState {
  scopes: {
    [scope: string]: DropdownScopeState;
  };
  loading: boolean;
  error: string | null;
}

export const initialDropdownState: DropdownState = {
  scopes: {
    COMMON: {
      common: {},
      countries: [],
      states: [],
      lgas: []
    }
  },
  loading: false,
  error: null
};